module.exports = __webpack_public_path__ + "static/img/lifestyle_17.60faa22f.jpg";